// extracted by mini-css-extract-plugin
module.exports = {"disableInteraction":"idt-useinteractionlock_disableinteraction__nks2g"};